import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { FilterConfigDynamic } from '@/types/filter';

const CUBE_NAME = 'competitor_partner_score';
const DIMENSION = `${CUBE_NAME}.competitor`;

const competitorCompetitorFilter: FilterConfigDynamic = {
  label: 'main.hcpOverview.partnerScore.filter.competitor.label',
  placeholder: 'main.hcpOverview.partnerScore.filter.competitor.placeholder',
  type: 'multiselect',
  defaultValue: [],
  clearable: true,
  searchable: true,
  sourceCube: CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [DIMENSION],
    filters: [{ member: DIMENSION, operator: 'set' }],
    order: { [DIMENSION]: 'asc' },
    limit: 10000,
  }),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    return { member: DIMENSION, operator: 'equals', values: [...v] };
  },
};

export default competitorCompetitorFilter;
